import { render, staticRenderFns } from "./GetNumberLinks.vue?vue&type=template&id=41487846&"
import script from "./GetNumberLinks.vue?vue&type=script&lang=js&"
export * from "./GetNumberLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports